import React from 'react';
import { FaGlobe, FaArrowRight } from 'react-icons/fa';

const GlobeExportIcon = ({ className = 'w-6 h-6', ...props }) => (
  <span className={`relative inline-flex ${className}`} {...props}>
    <FaGlobe className="w-full h-full" />
    <FaArrowRight className="absolute right-0 top-0 w-3 h-3 text-white bg-[#5C1F33] rounded-full p-0.5" />
  </span>
);

export default GlobeExportIcon;
